import { FC } from "react";

/**
 * The indicator separator component.
 */
export const IndicatorSeparator: FC = () => {
  return null;
};
